import redPin from '@components/map/assets/PN_Map_Marker.png';
import bluePin from '@components/map/assets/marker-icon.png';
import searchMarker from '@components/map/assets/search-marker-icon.png';
import { clusterSVG, fullscreenSVG } from '@utils/svg';
import { mdiMagnify, mdiPlus, mdiMinus, mdiLayersTriple, mdiClose } from '@mdi/js';

export const leafletAttribution = `
        <span title="Copyright (c) 2010-2025, Volodymyr Agafonkin
        Copyright (c) 2010-2011, CloudMade
        All rights reserved.">Powered by <a href='#'>Leaflet</a></span>
      `;

export const PNmapUseTipsList = [
  {
    icon: bluePin,
    label: 'Blue Pin',
    text: 'This pin indicates the location of a Public Notice.  Clicking the pin allows the user to view the Public Notice and/or to provide comments',
    type: 'img',
    width: 17,
    height: 24,
  },
  {
    icon: redPin,
    label: 'Red Pin',
    text: 'This pin indicates a Public Notice that has not been assigned a specific location on the map',
    type: 'img',
    width: 17,
    height: 24,
  },
  {
    icon: mdiPlus,
    label: 'Zoom In',
    text: 'Click the plus sign to zoom in on the map. You can also click one in the map and use the scroll wheel on your mouse to zoom in and out. With the focus of your cursor on the map, you can pan the map with the hand icon',
    type: 'icon',
  },
  {
    icon: mdiMinus,
    label: 'Zoom Out',
    text: 'Click the minus sign to zoom out on the map. See above for further map navigation tips',
    type: 'icon',
  },
  {
    icon: fullscreenSVG,
    label: 'Full Screen',
    text: 'Click the full screen icon to zoom out to the original extent of the map',
    type: 'svg',
  },
  {
    icon: mdiMagnify,
    label: 'Search',
    text: 'Use this component to search for a location via text (address, city, point of interest etc.)',
    type: 'icon',
  },
  {
    icon: searchMarker,
    label: 'Search Marker',
    text: 'This marker is used to indicate the location of the search result',
    type: 'img',
  },
  {
    icon: mdiClose,
    label: 'Reset Map',
    text: 'Use this icon to reset the map to its original state after using the search component. This icon is only visible when the "Search Marker" is present',
    type: 'icon',
  },
  {
    icon: mdiLayersTriple,
    label: 'Layers',
    text: 'Mouse over the layers icon to view the available base maps. The base map can either be viewed as a street map, aerial imagery, or topographic map',
    type: 'icon',
    height: 22,
  },
  {
    icon: clusterSVG,
    label: 'Cluster Marker',
    text: 'The cluster marker indicates that more than one Public Notice is located in the same general area; In order to view the Public Notices, click on the cluster marker.  The related individual Public Notices will be displayed (with a Blue Pin) which then can be clicked to view the Public Notice and/or to provide comments',
    type: 'svg',
  },
];
